import { isAndroidAvailable } from '../android/seeker/services'
import { getMethod } from '../utils/functions'

const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL_ADS

export const COMMON_ENDPOINTS = {
  QUALIFICATION_COURSES: '/classifieds/qualification/courses/',
  QUALIFICATION_CERTIFICATES: '/classifieds/qualification/certificates/',
  QUALIFICATION_SEARCH: '/classifieds/qualification/search/',

  CATEGORY_ROLES: '/classifieds/v2/primary-job-roles/search/',
  PRIMARY_SKILLS: '/classifieds/v1/primary-job-roles/',
}

export async function getNonSearchableItems(endpoint, params = {}, headers = {}) {
  return getMethod({
    url: `${BASE_URL}${endpoint}`,
    params,
    headers,
    withstatusCode: true,
    isAndroidWebview: isAndroidAvailable(),
    isTokenPresent: false,
  })
}

export async function getSearchableList({ endpoint, params = {}, headers = {} }) {
 return getMethod({
   url: `${BASE_URL}${endpoint}`,
   params,
   headers,
   withstatusCode: true,
   isAndroidWebview: isAndroidAvailable(),
   isTokenPresent: false,
 })
}

export async function fetchQualificationSearch({ q = '', qualificationId = null, pageNum = 1 }, headers = {}) {
 return getMethod({
   url: `${BASE_URL}${COMMON_ENDPOINTS.QUALIFICATION_SEARCH}`,
   params: {
     text: q,
     qualification_id: qualificationId,
     page: pageNum
   },
   headers,
   withstatusCode: true,
   isAndroidWebview: isAndroidAvailable(),
   isTokenPresent: false,
 })
}

export async function fetchQualificationCourses(qualificationId, headers) {
 return getMethod({
   url: `${BASE_URL}${COMMON_ENDPOINTS.QUALIFICATION_COURSES}`,
   params: { qualification_id: qualificationId },
   headers,
   withstatusCode: true,
   isAndroidWebview: isAndroidAvailable(),
   isTokenPresent: false,
 })
}

export async function fetchQualificationCertificates(courseId, headers, signal = null) {
 return getMethod({
   url: `${BASE_URL}${COMMON_ENDPOINTS.QUALIFICATION_CERTIFICATES}`,
   params: { course_id: courseId },
   headers,
   withstatusCode: true,
   isAndroidWebview: isAndroidAvailable(),
   isTokenPresent: false,
   signal
 })
}

export async function fetchPrimaryJobRoles({ qualificationId, experienceId, queryString, headers }) {
  const paramsObj = {
    group_by: 'job_category'
  }
  if (qualificationId) paramsObj.qualification_id = qualificationId
  if (experienceId) paramsObj.experience_id = experienceId
  if (queryString && queryString.trim().length >= 3) {
    paramsObj.q = queryString.trim()
  }

  return getMethod({
    url: `${process.env.NEXT_PUBLIC_BASE_URL_ADS}${COMMON_ENDPOINTS.CATEGORY_ROLES}`,
    params: paramsObj,
    headers,
    withstatusCode: true,
    isAndroidWebview: isAndroidAvailable(),
    isTokenPresent: false,
  })
}

export async function fetchSkillsForRoles(roleIds = [], headers) {
  const searchParams = new URLSearchParams()
  searchParams.set('skills', 'true')

  roleIds.forEach((rid) => {
    searchParams.append('primary_role', rid)
  })

    const baseUrl = `${process.env.NEXT_PUBLIC_BASE_URL_ADS}${COMMON_ENDPOINTS.PRIMARY_SKILLS}`
  const finalUrl = `${baseUrl}?${searchParams.toString()}`

  return getMethod({
    url: finalUrl,
    headers,
    withstatusCode: true,
    isAndroidWebview: isAndroidAvailable(),
    isTokenPresent: false,
  })
}
